import React, { useState } from "react";
import PropTypes from "prop-types";
import VizSensor from "react-visibility-sensor";
import { trackDesktopCustomEventsAU } from "../../../tracking";

const TrackableCarCardItem = ({ children, event, eventGA4, eventCallBack }) => {
    const { name, data } = event;
    const { name: nameGA4, data: dataGA4 } = eventGA4;
    const [isViewed, setIsViewed] = useState(false);

    const onChangeCardVisibility = (isVisible) => {
        if (isVisible && !isViewed) {
            trackDesktopCustomEventsAU(name, data);
            trackDesktopCustomEventsAU(nameGA4, dataGA4);
            if (eventCallBack) {
                eventCallBack();
            }
            setIsViewed(true);
        }
    };

    return (
        <VizSensor
            onChange={onChangeCardVisibility}
        >{children}</VizSensor>
    );
};

TrackableCarCardItem.propTypes = {
    children: PropTypes.object,
    event: PropTypes.object,
    eventGA4: PropTypes.object,
    eventCallBack: PropTypes.func
};

export default TrackableCarCardItem;
